<template>
  <div :class="[ns.b(), statusNs, isSimple && ns.is('simple')]">
    <i :class="[ns.e('inner')]" />
    <div :class="[ns.e('icon'), isPropsIcon && !isSimple && ns.is('custom')]">
      <div v-if="!isSimple" :class="[ns.e('wrapper')]">
        <Icon v-if="!slots?.icon && icon && !isSimple">
          <component :is="icon" />
        </Icon>
        <slot v-else-if="slots?.icon" name="icon" v-bind="vBind" />
        <span v-else>{{ index + 1 }}</span>
      </div>
      <div v-else :class="[ns.e(isSimple && 'dot')]" />
    </div>
    <div :class="[ns.e('content')]">
      <div :class="[ns.e('title')]">
        <span v-if="!slots?.title">{{ title || defaultTitle }}</span>
        <slot v-else name="title" v-bind="vBind" />
      </div>
      <div :class="[ns.e('extra')]">
        <slot />
        <span>{{ description }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {
  computed,
  getCurrentInstance,
  inject,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  useSlots,
  watch,
} from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { Icon } from '@xzx-design/components'
import { CheckSmall, CloseSmall } from '@xzx-design/icons-vue'
import { stepProps } from './step'

import type { Ref } from 'vue'

defineOptions({
  name: 'XzxStep',
})

export interface StepItemState {
  uid: number
  currentStatus: string
  setIndex: (val: number) => void
  calcProgress?: (status: string) => void
}

export interface IStepsProps {
  space: number | string
  active: number
  direction: string
  alignCenter: boolean
  simple: boolean
  processStatus: string
}

export interface IStepsInject {
  props: IStepsProps
  steps: Ref<StepItemState[]>
  addStep: (item: StepItemState) => void
  removeStep: (uid: number) => void
}

const props = defineProps(stepProps)

const slots = useSlots()
const currentInstance = getCurrentInstance()

const status = ref('')
const index = ref(-1)

const iconMap: { [key: string]: any } = {
  error: CloseSmall,
  finish: CheckSmall,
}
const icon = computed(() => props.icon || iconMap[currentStatus.value])

const isPropsIcon = computed(() => {
  return !!props.icon || !!slots?.icon
})

const isSimple = computed(() => {
  return parent.props.simple
})

const vBind = computed(() => ({
  status: currentStatus.value,
}))

const parent = inject('XzxSteps') as IStepsInject

const ns = useNamespace('step')

const statusNs = computed(() => ns.is(currentStatus.value))
const currentStatus = computed(() => {
  return props?.status || status.value
})

const titleMap: { [key: string]: string } = {
  wait: '未开始',
  process: '进行中',
  finish: '已完成',
  error: '已失败',
}
const defaultTitle = computed(() => titleMap[currentStatus.value])

const prevStatus = computed(() => {
  const prevStep = parent.steps.value[index.value - 1]
  return prevStep ? prevStep.currentStatus : 'wait'
})

const updateStatus = (active: number) => {
  if (active === index.value && prevStatus.value !== 'error') {
    status.value = parent.props.processStatus
  } else if (active > index.value) {
    status.value = 'finish'
  } else {
    status.value = 'wait'
  }
}

const setIndex = (val: number) => {
  index.value = val
}

onMounted(() => {
  watch(
    [() => parent.props.active, () => parent.props.processStatus],

    ([active]) => {
      updateStatus(active)
    },
    { immediate: true }
  )
})

onBeforeUnmount(() => {
  parent.removeStep(stepItemState.uid)
})

const stepItemState = reactive({
  uid: currentInstance!.uid,
  currentStatus,
  setIndex,
  // calcProgress,
})
parent.addStep(stepItemState)
</script>
